import { render, staticRenderFns } from "./DenunciaPrint.vue?vue&type=template&id=efa9261a&scoped=true"
import script from "./DenunciaPrint.vue?vue&type=script&lang=js"
export * from "./DenunciaPrint.vue?vue&type=script&lang=js"
import style0 from "./DenunciaPrint.vue?vue&type=style&index=0&id=efa9261a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa9261a",
  null
  
)

export default component.exports